import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  useGetLocationTypesMutation,
  useUpdateLocationTypeMutation
} from '../../../services/locations/locationsService';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';
import { SideBarSimpleMethodItem } from '../../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';
import { SelectItemMethod } from '../../../components/commons/SideBarComponents/SelectItemMethod/selectItemMethod';

interface ChangeLocationTypeProps {
  selectedLocation: { locationId: number; locationType: number; name: string };
  setOpenRightSideBar: (open: boolean) => void;
  reloadTable: () => void;
}
export const ChangeLocationType = ({
  selectedLocation,
  setOpenRightSideBar,
  reloadTable
}: ChangeLocationTypeProps) => {
  const [changedLocationType, setChangedLocationType] = useState(
    selectedLocation.locationType
  );
  const [
    getLocationTypes,
    {
      isLoading: isLoadingLocationTypes,
      isSuccess: isSuccessLocationTypes,
      data: locationTypesData
    }
  ] = useGetLocationTypesMutation();
  const [
    updateLocationType,
    {
      isLoading: isLoadingUpdateLocationType,
      isSuccess: isSuccessUpdateLocationType
    }
  ] = useUpdateLocationTypeMutation();

  const handleChangeLocationType = () => {
    updateLocationType({
      locationId: selectedLocation.locationId,
      locationType: changedLocationType
    });
  };
  useEffect(() => {
    getLocationTypes();
  }, []);

  useEffect(() => {
    if (isSuccessUpdateLocationType) {
      toast.success(Strings.locations.locationTypeUpdated);
      setOpenRightSideBar(false);
      reloadTable();
    }
  }, [isSuccessUpdateLocationType]);
  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.locations.changeLocationType}
        </StyledTitleSideBar>
        {isSuccessLocationTypes && (
          <SelectItemMethod
            item={{
              label: Strings.locations.locationType,
              currentValue: changedLocationType,
              options:
                locationTypesData?.map((type) => ({
                  id: type.id,
                  name: type.name
                })) ?? [],
              onChange: (e) => setChangedLocationType(+e.target.value),
              placeholder: Strings.locations.locationType
            }}
          />
        )}
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
          }}
        >
          {Strings.common.cancel}
        </button>
        <button
          type="button"
          className="btn-save"
          disabled={
            isLoadingLocationTypes ||
            changedLocationType === selectedLocation.locationType
          }
          onClick={() => {
            handleChangeLocationType();
          }}
        >
          {Strings.common.save}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
